import styled from "styled-components";
import { BTTO_PROFILE_COLORS, bettoFocusRing } from "../../shared/elements";

export const ShellRoot = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 1200px;
	margin: 0 auto;
	min-height: calc(100vh - var(--bt-header-height, 62px) - 40px);
`;

export const ShellHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	padding: 16px 16px 0;
	margin-bottom: 4px;

	@media (min-width: 768px) {
		padding: 20px 24px 0;
	}
`;

export const ShellHeaderLeft = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
	flex: 1;
`;

export const ShellBackButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	flex-shrink: 0;
	padding: 8px 10px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	border-radius: 8px;
	background: ${BTTO_PROFILE_COLORS.surfaceRaised};
	color: ${BTTO_PROFILE_COLORS.textMuted};
	font-size: 12px;
	font-weight: 600;
	line-height: 1;
	text-transform: uppercase;
	cursor: pointer;
	transition:
		background 0.2s ease,
		border-color 0.2s ease,
		color 0.2s ease;
	${bettoFocusRing}

	svg {
		width: 16px;
		height: 16px;
	}

	&:hover {
		background: ${BTTO_PROFILE_COLORS.surfaceHover};
		border-color: ${BTTO_PROFILE_COLORS.borderActive};
		color: ${BTTO_PROFILE_COLORS.text};
	}
`;

export const ShellCloseLink = styled.a`
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 40px;
	height: 40px;
	border-radius: 8px;
	color: ${BTTO_PROFILE_COLORS.textMuted};
	cursor: pointer;
	transition: background 0.2s ease;
	${bettoFocusRing}

	&:hover {
		background: ${BTTO_PROFILE_COLORS.surface};
		color: ${BTTO_PROFILE_COLORS.text};
	}

	svg {
		width: 24px;
		height: 24px;
	}
`;

export const ShellBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	padding: 0 16px;

	@media (min-width: 768px) {
		padding: 0 24px;
	}

	@media (min-width: 1024px) {
		flex-direction: row;
		align-items: flex-start;
		gap: 20px;
	}
`;

export const ShellNavColumn = styled.aside`
	flex-shrink: 0;
	width: 100%;

	@media (min-width: 1024px) {
		width: 200px;
	}
`;

export const ShellContentColumn = styled.main`
	flex: 1;
	min-width: 0;
	width: 100%;
`;

export const MobileNavSelect = styled.select`
	display: block;
	width: 100%;
	padding: 10px 12px;
	border-radius: 8px;
	border: 1px solid ${BTTO_PROFILE_COLORS.border};
	background: ${BTTO_PROFILE_COLORS.surface};
	color: ${BTTO_PROFILE_COLORS.text};
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	${bettoFocusRing}

	@media (min-width: 1024px) {
		display: none;
	}
`;

export const DesktopNav = styled.div`
	display: none;

	@media (min-width: 1024px) {
		display: block;
	}
`;
